import styled from '@emotion/styled/macro';
import { theme } from 'styles/theme';

export const FormHeader = styled.h2`
  margin-bottom: ${theme.space[6]};
  font-size: ${theme.fontSizes.xl};
  font-family: ${theme.fonts.medium};
`;
